export default __webpack_public_path__ + "static/music-nav-3c4a6e9a8afccc17ad68bce7a55779ec.svg";